<template>
    <div class="fish-manage">
       <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "FishManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
